// extracted by mini-css-extract-plugin
module.exports = {"reviewer-bigcontainer":"Reviewer_reviewer-bigcontainer__3l6VK","reviewer-container":"Reviewer_reviewer-container__2W82l"};